import React from 'react'
// import styled from 'styled-components'

import TextArea from 'antd/lib/input/TextArea'

// const Label = styled.div`
//   display: grid;
//   align-content: center;
//   justify-content: end;
// `

const CalpCard97Extension = props => {
  const {
    // eslint-disable-next-line no-unused-vars
    allData = {},
    data = {},
    handleExtSave,
    // mode = 'V',
    // lock = 'U',
    // isAdmin = false,
    disableComp = false,
  } = props

  // const { eventType = 'U1' } = allData

  // eslint-disable-next-line no-unused-vars
  const { string7 = 'N', extendedDes = '', number1 } = data

  // const onChange = (checked, id) => handleExtSave(id, checked ? 'Y' : 'N')

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'auto',
        // gridTemplateRows: 'auto auto',
        gridRowGap: '5px',
        // gap: '10px',
      }}
    >
      {/* <Switch
        disabled={disableComp || eventType === 'RS' || eventType === 'NC'}
        style={{ width: '300px', marginTop: '50px' }}
        checked={string7 === 'Y'}
        onChange={checked => onChange(checked, 'string7')}
        checkedChildren="Relay Mis-Operations"
        unCheckedChildren="Not Relay Mis-Operations"
      /> */}
      {/* 
       this is moved to main tab
      <div>Gross Available Capacity (MW) :</div>
      <InputNumber
        style={{ width: '200px' }}
        value={number1}
        onChange={value => handleExtSave('number1', value)}
        disabled={disableComp}
      /> */}
      <div />
      <div style={{ marginTop: '5px', gridColumnEnd: 'span 1' }}>
        Extended Description :
      </div>
      <TextArea
        style={{ gridColumnEnd: 'span 1' }}
        value={extendedDes}
        onChange={e => handleExtSave('extendedDes', e.target.value)}
        rows={5}
        disabled={disableComp}
      />
      {/* <Label>Relay Mis-Operations :</Label>
      <div style={{ display: 'grid', alignContent: 'center' }}>
        <Switch
          disabled={disableComp}
          style={{ display: 'grid', alignContent: 'center' }}
          checkedChildren="Yes"
          unCheckedChildren="No"
          onChange={checked => onChange(checked, 'primaryAlert')}
          checked={string3 === 'Y'}
        />
      </div>
      <Label>Not Relay Mis-Operations :</Label>
      <div style={{ display: 'grid', alignContent: 'center' }}>
        <Switch
          disabled={disableComp}
          style={{ display: 'grid', alignContent: 'center' }}
          checkedChildren="Yes"
          unCheckedChildren="No"
          onChange={checked => onChange(checked, 'includeInMmpi')}
          checked={string3 !== 'Y'}
        />
      </div> */}
    </div>
  )
}

export default CalpCard97Extension
